import React, { useState, useEffect } from 'react'
import { SettleScaniaPrint } from "@/components/SettleScaniaPrint"
import { formatNum, numberParseChina, momentFormat } from '@/utils/utils';
import { useAppointmentModel } from '../appointmentModel';
import { appointmentService } from "../appointmentService"
import { IMaterialDetailList, IItemDetailList, IAppointmentDetail } from '../appointmentType';
import moment from 'moment';
import useGlobalModel from '@/model/globalModel';
export const SettleScaniaPrints = ({
}) => {
    // settleScaniaPrint, setSettleScaniaPrint
    const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()

    const { settleScaniaPrint: visible, selectedRow, setSettleScaniaPrint } = useAppointmentModel()
    const onClose = () => {
        setSettleScaniaPrint(false)
    }
    const [formVal, setFormVal] = useState<IAppointmentDetail>({});
    const [maintenanceList, setMaintenanceList] = useState<IMaterialDetailList[]>([]);
    const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    useEffect(() => {
        visible && getDetailOne()
    }, [visible])
    const getDetailOne = async () => {
        let { retData } = await appointmentService.one(selectedRow.appointmentCode as string);
        let { itemDetails, materialDetails, receivableTotalAmount, enterTime, deliveryTime, ...from } = retData
        receivableTotalAmount = formatNum(receivableTotalAmount)
        // deliveryTime
        const newItemDetails = itemDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        const newMaterialDetails = materialDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        if (retData) {
            setMaintenanceList(newMaterialDetails as IMaterialDetailList[] ?? []);
            setItemList(newItemDetails as IItemDetailList[] ?? []);
            setFormVal({ ...from, maintenanceCode: from.appointmentCode, receivableTotalAmount, receivableTotalAmountCN: numberParseChina(receivableTotalAmount), deliveryTime: momentFormat(deliveryTime), enterTime: momentFormat(enterTime) })
        }
    }
    const itemClumns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '项目名称',
            dataIndex: 'itemName',
        },
        {
            title: '项目编号',
            dataIndex: 'itemCode',
        },
        {
            title: '工时',
            dataIndex: 'workHour',
        },
        {
            title: '单价',
            dataIndex: 'price',
        },
        {
            title: '工时费',
            dataIndex: 'itemAmount',
        },
        {
            title: '备注',
            dataIndex: 'note',
        },
    ]
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '材料编号',
            dataIndex: 'materialCode',
        },
        {
            title: '材料名称',
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            dataIndex: 'unitName',
        },
        {
            title: '数量',
            dataIndex: 'num',
        },
        {
            title: '单价',
            dataIndex: 'price',
        },
        {
            title: '金额',
            dataIndex: 'receivableAmount',
        },
        {
            title: '备注',
            dataIndex: 'note',
        },
    ]
    let IHeader = [
        {
            fieldLabel: "工号：",
            fieldValue: formVal.maintenanceCode
        }, {
            fieldLabel: "支付方式：",
            fieldValue: formVal.paymentMethodName
        }, {
            fieldLabel: "打印日期：",
            fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
        },
    ]
    return <SettleScaniaPrint
        title={`${shopName}`}
        visible={visible}
        onClose={onClose}
        columns={columns}
        itemClumns={itemClumns}
        itemDataSource={itemList}
        dataSource={maintenanceList.filter(item => item.num !== 0)}
        formVal={formVal}
        shopCode={shopCode}
    />
}